import React from "react";
import SearchBookingTableB2B from "../../componentes/Tabla/SearchBookingTableB2B";

export default function BuscadorB2B() {
  return (
    <SearchBookingTableB2B />
  )
}